import React from "react";

import { Network } from "../../services/NetworkApi";
import {
  Portfolio
} from "../../services/PortfolioApi";
import { useNetwork } from "../../hooks/useNetwork";
import { EnhancedTreeItem } from "./EnhancedTreeItem";
import { UnitTypeTreeItem } from "./UnitTypeTreeItem";
import { useSubnetworkRename } from "./useSubnetworkRename";
import { IProps } from "./SubnetworksTree";
import { CreateUnitModal } from "../../routes/super_admin/network_settings/modals/CreateUnitModal";
import { CloneSubnetworkModal } from "../../routes/super_admin/network_settings/modals/CloneSubnetworkModal";
import {CloneRoomModal} from "../../routes/super_admin/network_settings/modals/CloneRoomModal";

interface SubnetworksTreeProps {
  subnetwork: Network;
  subtitle1: string;
  portoflio: Portfolio;
}

export const SubnetworkTreeItem: React.FC<IProps & Network & SubnetworksTreeProps> = (props) => {
  const { getL3Options } = useNetwork();
  const handleRename = useSubnetworkRename(props.l2Id);
  const [isCreateUnitModal, setIsCreateUnitModal] = React.useState(false);
  const [isCloneModal, setIsCloneModal] = React.useState(false);
  const [isCloneL3ModalVisible, setIsCloneL3ModalVisible] = React.useState(false);
  const { subnetwork } = props;

  const title = props.isPreview ? `MATCHING ROUND: ${props.l2Name}` : `Matching Round Name: ${props.l2Name}`;
  const subtitle = props.subtitle1? props.subtitle1 : `Matching Round l2Id: ${props.l2Id}`;
  const nodeId = `${props.l1Name}-${props.l2Id}`;
  const unitTypes = getL3Options(props.l1Id, props.l2Id);

  const openCloneL3Modal = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    setIsCloneL3ModalVisible(true);
  };

  const closeCloneL3Modal = () => setIsCloneL3ModalVisible(false);

  const openCreateUnitModal = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    setIsCreateUnitModal(true);
  };

  const openCloneModal = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    setIsCloneModal(true);
  };

  const closeCreateUnitModal = () => setIsCreateUnitModal(false);
  const closeCloneModal = () => setIsCloneModal(false);

  const L2CreationActionBtns = props.subnetwork.matchingRoundStatus !== "CLOSED" && props.subnetwork.matchingRoundStatus !== "ARCHIVED"?
  [
    {label: `Add new unit for ${props.l2Name}`, handler: openCreateUnitModal},
    {label: `Clone ${props.l2Name}`, handler: openCloneModal},
    {label: `Clone L3s`, handler: openCloneL3Modal},
  ] :
  [
    {label: `Clone ${props.l2Name}`, handler: openCloneModal},
    {label: `Clone L3s`, handler: openCloneL3Modal},
  ];

  return (
    <>
      <EnhancedTreeItem
        key={`${props.l1Name}-${props.l2Id}`}
        title={title}
        nodeId={nodeId}
        name={props.l2Name}
        subtitle1={subtitle}
        isPreview={props.isPreview}
        onEdit1Success={handleRename}
        subnetwork={props.subnetwork}
        actionButtons={L2CreationActionBtns}
      >
        {unitTypes.map((unitType) => (
          <UnitTypeTreeItem key={unitType.l3Id} subnetwork={props} unitType={unitType} isPreview={props.isPreview} />
        ))}
      </EnhancedTreeItem>
      {!props.isPreview && (
        <CreateUnitModal l1Id={props.l1Id} l2Id={props.l2Id} l2Name={props.l2Name} portfolio={props.portfolio} show={isCreateUnitModal} onClose={closeCreateUnitModal} />
      )}
      {!props.isPreview && (
        <CloneSubnetworkModal 
          show={isCloneModal} 
          onClose={closeCloneModal} 
          l2Name={subnetwork.l2Name} 
          l1Id={subnetwork.l1Id}
          l2Id={subnetwork.l2Id}
          matchingRoundStatus={subnetwork.matchingRoundStatus}
          activationStartDate={subnetwork.activationStartDate}
          activationEndDate={subnetwork.activationEndDate}
          matchingStartDate={subnetwork.matchingStartDate}
          matchingEndDate={subnetwork.matchingEndDate}
        />
      )}
      {!props.isPreview && (
          <CloneRoomModal show={isCloneL3ModalVisible} onClose={closeCloneL3Modal} l1Id={props.l1Id} l2Id={subnetwork.l2Id}/>
      )}
    </>
  );
};
